var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.3337 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 5.83333C12.0417 5.83333 11.6667 5.45833 11.6667 5V4.16667C11.6667 2.78333 10.55 1.66667 9.16667 1.66667C7.78333 1.66667 6.66667 2.78333 6.66667 4.16667V5C6.66667 5.45833 6.29167 5.83333 5.83333 5.83333C5.375 5.83333 5 5.45833 5 5V4.16667C5 1.86667 6.86667 0 9.16667 0C11.4667 0 13.3333 1.86667 13.3333 4.16667V5C13.3333 5.45833 12.9583 5.83333 12.5 5.83333Z",
    fill: "url(#paint0_linear_0_31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.16667 12.5C6.86667 12.5 5 10.6333 5 8.33333C5 7.875 5.375 7.5 5.83333 7.5C6.29167 7.5 6.66667 7.875 6.66667 8.33333C6.66667 9.71667 7.78333 10.8333 9.16667 10.8333C10.55 10.8333 11.6667 9.71667 11.6667 8.33333C11.6667 7.875 12.0417 7.5 12.5 7.5C12.9583 7.5 13.3333 7.875 13.3333 8.33333C13.3333 10.6333 11.4667 12.5 9.16667 12.5Z",
    fill: "var(--fill-0, #119ED9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3333 20H5C2.24167 20 0 17.7584 0 15L0.841667 6.58338C0.875 5.23338 1.98333 4.15838 3.33333 4.16671H15C16.3833 4.16671 17.5 5.28338 17.5 6.66671L18.3333 14.9167C18.3667 17.6917 16.15 19.9667 13.3833 20C13.3667 20 13.35 20 13.3333 20ZM3.33333 5.83338C2.875 5.83338 2.5 6.20838 2.5 6.66671L1.66667 15.0834C1.70833 16.8917 3.19167 18.3417 5 18.3334H13.3333C15.175 18.3334 16.6667 16.8417 16.6667 15L15.8333 6.75005C15.8667 6.27505 15.5 5.86671 15.025 5.83338C15.025 5.83338 15.0167 5.83338 15 5.83338H3.33333Z",
    fill: "url(#paint1_linear_0_31)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_31",
    x1: 4.94937,
    y1: 0.254067,
    x2: 13.8252,
    y2: 4.54428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_31",
    x1: -0.111389,
    y1: 4.85628,
    x2: 20.7726,
    y2: 13.0382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBag);
export default __webpack_public_path__ + "static/media/cart_bag.d6ec2c5e678c77bc18063023d2ca8e02.svg";
export { ForwardRef as ReactComponent };